const translations = {
  en: {
    showOrder: "Show order",
    total: "TOTAL",
    chooseTable: "CHOOSE A TABLE",
    note: "NOTE",
    placeOrder: "ORDER",
    size: "Size",
    quantity: "Quantity",
    order: "ORDER",
    chooseSize: "Choose size",
    flavor: "Flavor",
    orderRecieved: "Your order has been received!",
    backToMenu: "BACK TO MENU",
    choose: "Choose",
    sideDishes: "SIDE DISHES",
    addToCart: "ADD TO CART",
    selected: "Selected",
    followOrder: "FOLLOW ORDER",
    completed: "Completed",
    processing: "In process",
    orderStatus: "ORDER STATUS",
    orderNumber: "ORDER NUMBER",
    enjoyInMeal: "Enjoy your meal, bon appétit!",
    visitSocials: "For new offers, visit our social media.",
    pageRefresh: "Refresh the page to check the status.",
    cartContent: "Cart content",
    weRecommend: "Along with this, we recommend",
  },
  bs: {
    showOrder: "Prikaži narudžbu",
    total: "UKUPNO",
    chooseTable: "ODABERI STO",
    note: "NAPOMENA",
    placeOrder: "NARUČI",
    size: "Veličina",
    quantity: "Količina",
    order: "NARUDŽBA",
    chooseSize: "Odaberi veličinu",
    flavor: "Okus",
    orderRecieved: "Vaša narudžba je primljena!",
    backToMenu: "NAZAD NA MENI",
    choose: "Izaberi",
    sideDishes: "PRILOZI",
    addToCart: "DODAJ U KORPU",
    selected: "Odabir",
    followOrder: "PRATI NARUDŽBU",
    completed: "Gotovo",
    processing: "U pripremi",
    orderStatus: "STATUS NARUDŽBE",
    orderNumber: "BROJ NARUDŽBE",
    enjoyInMeal: "Uživaj u jelu, prijatno!",
    visitSocials: "Za nove ponude, posjeti naše društvene mreže",
    pageRefresh: "Osvježi stranicu za provjeru statusa.",
    cartContent: "Sadržaj korpe",
    weRecommend: "Uz ovo preporučujemo",
  },
  de: {
    showOrder: "Zeige bestellung",
    total: "INSGESAMT",
    chooseTable: "WÄHLE EINEN TISCH",
    note: "HINWEIS",
    placeOrder: "BESTELLUNG",
    size: "Größe",
    quantity: "Menge",
    order: "BESTELLUNG",
    chooseSize: "Größe wählen",
    flavor: "Geschmack",
    orderRecieved: "Ihre Bestellung wurde erhalten!",
    backToMenu: "ZURÜCK ZUM MENÜ",
    choose: "Wählen",
    sideDishes: "BEILAGEN",
    addToCart: "IN DEN WARENKORB LEGEN",
    selected: "Auswahl",
    followOrder: "FOLGE BESTELLUNG",
    completed: "abgeschlossen",
    processing: "in bearbeitung",
    orderStatus: "BESTELLSTATUS",
    orderNumber: "BESTELLNUMMER",
    enjoyInMeal: "Guten Appetit!",
    visitSocials: "Für neue Angebote, besuche unsere sozialen Medien.",
    pageRefresh: "Aktualisiere die Seite, um den Status zu überprüfen.",
    cartContent: "Inhalt des Warenkorbs",
    weRecommend: "Dazu empfehlen wir",
  },
  es: {
    showOrder: "Mostrar orden",
    total: "TOTAL",
    chooseTable: "ELIGE UNA MESA",
    note: "NOTA",
    placeOrder: "ORDERNAR",
    size: "Tamaño",
    quantity: "Cantidad",
    order: "ORDEN",
    chooseSize: "Elige el tamaño",
    flavor: "Sabor",
    orderRecieved: "¡Se ha recibido su pedido!",
    backToMenu: "VOLVER AL MENÚ",
    choose: "Elegir",
    sideDishes: "ACOMPAÑAMIENTOS",
    addToCart: "AGREGAR AL CARRITO",
    selected: "Elección",
    followOrder: "SEGUIR ORDEN",
    completed: "Completado",
    processing: "en proceso",
    orderStatus: "ESTADO DEL PEDIDO",
    orderNumber: "NÚMERO DE PEDIDO",
    enjoyInMeal: "¡Disfruta tu comida, buen provecho!",
    visitSocials: "Para nuevas ofertas, visita nuestras redes sociales.",
    pageRefresh: "Actualiza la página para verificar el estado.",
    cartContent: "Contenido del carrito",
    weRecommend: "Junto con esto, recomendamos",
  },
  fr: {
    showOrder: "Afficher la commande",
    total: "TOTAL",
    chooseTable: "CHOISISSEZ UNE TABLE",
    note: "NOTE",
    placeOrder: "COMMANDER",
    size: "Taille",
    quantity: "Quantité",
    order: "COMMANDE",
    chooseSize: "Choisissez la taille",
    flavor: "Saveur",
    orderRecieved: "Votre commande a été reçue !",
    backToMenu: "RETOUR AU MENU",
    choose: "Choisir",
    sideDishes: "GARNITURES",
    addToCart: "AJOUTER AU PANIER",
    selected: "Choix",
    followOrder: "SUIVRE COMMANDE",
    completed: "terminé",
    processing: "en cours de traitement",
    orderStatus: "ÉTAT DE LA COMMANDE",
    orderNumber: "NUMÉRO DE COMMANDE",
    enjoyInMeal: "Bon appétit!",
    visitSocials: "Pour de nouvelles offres, visitez nos réseaux sociaux.",
    pageRefresh: "Rafraîchissez la page pour vérifier le statut.",
    cartContent: "Contenu du panier",
    weRecommend: "Avec cela, nous recommandons",
  },
  it: {
    showOrder: "Mostra ordine",
    total: "TOTALE",
    chooseTable: "SCEGLI UN TAVOLO",
    note: "NOTA",
    placeOrder: "ORDINARE",
    size: "Dimensione",
    quantity: "Quantita",
    order: "ORDINE",
    chooseSize: "Scegli la taglia",
    flavor: "Gusto",
    orderRecieved: "Il vostro ordine è stato ricevuto!",
    backToMenu: "INDIETRO AL MENU",
    choose: "Scegliere",
    sideDishes: "CONTORNI",
    addToCart: "AGGIUNGI AL CARRELLO",
    selected: "Scelta",
    followOrder: "SEGUI ORDINE",
    completed: "completato",
    processing: "in corso",
    orderStatus: "STATO DELL'ORDINE",
    orderNumber: "NUMERO D'ORDINE",
    enjoyInMeal: "Buon appetito!",
    visitSocials: "Per nuove offerte, visita i nostri social media.",
    pageRefresh: "Aggiorna la pagina per verificare lo stato.",
    cartContent: "Contenuto del carrello",
    weRecommend: "Insieme a questo, consigliamo",
  },
  tr: {
    showOrder: "Siparişi göster",
    total: "TOPLAM",
    chooseTable: "BİR MASA SEÇ",
    note: "NOT",
    placeOrder: "SİPARİŞ VER",
    size: "Boyut",
    quantity: "Miktar",
    order: "SİPARİŞ",
    chooseSize: "Boyut seçin",
    flavor: "Tat",
    orderRecieved: "Siparişiniz alındı!",
    backToMenu: "MENÜYE GERİ DÖN",
    choose: "Seç",
    sideDishes: "YAN LEZZETLER",
    addToCart: "SEPETE EKLE",
    selected: "Seçim",
    followOrder: "SİPARİŞ TAKİP",
    completed: "tamamlandı",
    processing: "işlemde",
    orderStatus: "SİPARİŞ DURUMU",
    orderNumber: "SİPARİŞ NUMARASI",
    enjoyInMeal: "Afiyet olsun!",
    visitSocials: "Yeni teklifler için sosyal medya hesaplarımızı ziyaret et.",
    pageRefresh: "Durumu kontrol etmek için sayfayı yenile.",
    cartContent: "Sepet içeriği",
    weRecommend: "Bununla birlikte, öneriyoruz",
  },
  sa: {
    showOrder: "عرض الطلب",
    total: "المجموع",
    chooseTable: "اختر طاولة",
    note: "ملاحظة",
    placeOrder: "قدم الطلب",
    size: "الحجم",
    quantity: "الكمية",
    order: "طلب",
    chooseSize: "اختر الحجم",
    flavor: "النكهة",
    orderRecieved: "تم استلام طلبك!",
    backToMenu: "العودة إلى القائمة",
    choose: "اختر",
    sideDishes: "الأطباق الجانبية",
    addToCart: "أضف إلى السلة",
    selected: "محدد",
    followOrder: "تتبع الطلب",
    completed: "مكتمل",
    processing: "قيد المعالجة",
    orderStatus: "حالة الطلب",
    orderNumber: "رقم الطلب",
    enjoyInMeal: "بالهنا والشفا!",
    visitSocials:
      "قم بزيارة حساباتنا على وسائل التواصل الاجتماعي للحصول على عروض جديدة.",
    pageRefresh: "قم بتحديث الصفحة للتحقق من الحالة.",
    cartContent: " محتوى السلة",
    weRecommend: "مع هذا، نوصي",
  },
};
export default translations;
